<!--/**
 * Componente Vue para visualizar un formulario con la informacion que le sea otorgada, esta informacion puede ser un JSON con datos,
 * un simple Array o un String (url) con el recurso a consumir.
 * @version 1.0.0
 * @author Santiago Urrego Giraldo.
 * @since 2017-04-06
 * @param items JSON con los nombres de los campos, label y datos adicionales que se va a mostrar en el formulario
 * Ejemplo:
 * [
 *     {
 *         name: 'first_name',              # name String Nombre del campo que viene en el recurso.
 *         label: 'Nombres',                # label String Nombre del campo para la cabecera.
 *         placeholder: 'ingrese nombre',   # placeholder String texto del campo cuando esta vacio.
 *         maxlength: '30',                 # maxlength int cantidad de caracteres permitidos por el campo.
 *         type: 'text',                    # type String tipo de contenido del campo.
 *         type: 'textarea',                # si el type es textarea se utilizara el control de tipo textarea.
 *              cols:'',                    # int que define la cantidad de columnas que tendra el textarea
 *              rows:'',                    # int que define la cantidad de filas que tendra el textarea
 *         type: 'select',                  # si el type es select se utilizara el control de tipo select.
 *              option:'',                  # string opcion que se visualizara en el select
 *              option.value                # valor de la opcion 
 *              option.text                 # texto de la opcion
 *      }
 * ]
 * Dependiendo el tipo de dato se mostrara el componente respectivo de cada campo al cual se le enviara el objeto actual del ciclo que se recorre para imprimir el formulario con los datos del campo especificamente
 * @param resource String con la url de recurso a consumir.
 * @param updateData Boolean permite mostrar el boton atras y el boton actualizar.
 * @param isLoading Boolean permite ocultar el boton guardar mientras responde el servicio.
 */-->
<template>
    <div method="post" action="" class="form-horizontal" role="form">
        <div class="form-group">
            <div v-for="item, key in items">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password' || item.type==='file'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-1'"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd" :disabled="item.disabled"></datepicker>
                <div v-if="item.type==='date'" v-for="error in item.errors" style="margin-left: 18px" id="errors">
                    <div class="clearfix"></div>
                    {{ error }}
                </div>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"><br></div>
            </div>
            <div class="clearfix"></div>
            <br>
            <div class="col-md-12 text-center">
                <div v-if="updateData">
                    <input type="button" class="btn btn-info" value="Atrás" name="Atrás" v-on:click="behind">
                    <input v-if="!isLoading"  type="button" class="btn btn-success" value="Actualizar" name="Actualizar" v-on:click="update" v-on:keyup.enter="update">
                    <span v-else>Cargando...</span>
                </div>
                <div v-else>
                    <input type="button" class="btn btn-info" value="Cancelar" name="Cancelar" v-on:click="cancel">
                    <input v-if="!isLoading" :disabled="isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="register">
                    <span v-else>Cargando...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import router from '@/router'
import EmtInput from '@/components/input-components/emt-input'
import EmtCheckbox from '@/components/input-components/emt-checkbox'
import EmtRadio from '@/components/input-components/emt-radio'
import EmtSelect from '@/components/input-components/emt-select'
import EmtTextarea from '@/components/input-components/emt-textarea'
import swal from 'sweetalert2'

export default {
    name: 'emt-form',
    data: function () {
        return {
            data: {
                form_values: {},
                errors: []
            },
            isLoading: false
        }
    },
    props: {
        resource: String,
        items: Array,
        updateData: Boolean
    },
    methods: {
        /**
         * metodo que permite recorrer el formulario y almacenar sus valores
         */
        getFormValues: function () {
            var self = this
            self.data.form_values = {}
            for (var i = 0; i < self.items.length; i++) {
                var value = null
                if (typeof self.items[i].value === 'string') {
                    value = self.items[i].value != null ? self.items[i].value.trim() : null
                } else {
                    value = self.items[i].value
                }
                self.data.form_values[self.items[i].name] = value
            }
            return self.data.form_values
        },
        /**
         * metodo que permite limpiar los formularios despues de realizar alguna acción
         */
        clearFormValues: function () {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].type === 'checkbox' || this.items[i].type === 'radio') {
                    this.items[i].value = false
                } else if (this.items[i].type === 'select') {
                    this.items[i].selectedIndex = 0
                    this.items[i].value = ''
                } else if (this.items[i].type === 'date') {
                    document.getElementsByName('date')[0].value = null
                } else {
                    this.items[i].value = ''
                }
            }
            for (i in this.items) {
                this.items[i].errors = []
            }
            return null
        },
        /**
         * metodo que permite el registro de información
         */
        register: function (table) {
            var self = this
            var values = self.getFormValues()
            self.isLoading = true
            self.$http.post(self.resource, values).then(function (response) {
                swal({
                    title: 'Se creó el registro exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                self.clearFormValues()
                self.$emit('register')
            }, function (response) {
                self.data.errors = response.body
                var prop = null
                for (var i in self.items) {
                    self.items[i].errors = []
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors = response.body[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
                self.isLoading = false
            })
            self.isLoading = false
        },
        updateDate: function (value) {
            for (var item in this.items) {
                value = value.toISOString().substring(0, 10)
                this.items[item].value = value
            }
        },
        update: function () {
            var self = this
            var values = self.getFormValues()
            self.isLoading = true
            self.$http.put(self.resource + this.$route.params.id + '/', values).then(function (response) {
                self.isLoading = false
                swal({
                    title: 'Se realizó la actualización exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.go(-1)
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                for (var i in self.items) {
                    self.items[i].errors = []
                }
                for (i in self.items) {
                    for (prop in self.data.errors) {
                        if (self.items[i].name === prop) {
                            self.items[i].errors = response.body[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
        },
        behind: function () {
            router.go(-1)
        },
        cancel: function () {
            var self = this
            swal({
                title: '¿Está seguro de cancelar?',
                text: 'Al cancelar se limpiarán todos los campos diligenciados.',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No'
            }).then((result) => {
                console.log('result: ', result)
                if (result) {
                    self.clearFormValues()
                }
            })
        },
        listener: function (e) {
            var self = this
            var containSwal = document.body.classList.contains('swal2-shown')
            if (e.key === 'Enter' && !containSwal) {
                if (self.updateData) {
                    self.update()
                } else {
                    self.register()
                }
            }
        }
    },
    mounted: function () {
        var self = this
        window.addEventListener('keyup', self.listener)
    },
    destroyed: function () {
        var self = this
        window.removeEventListener('keyup', self.listener)
    },
    components: {
        'emt-input': EmtInput,
        'emt-checkbox': EmtCheckbox,
        'emt-radio': EmtRadio,
        'emt-select': EmtSelect,
        'emt-textarea': EmtTextarea,
        'datepicker': Datepicker
    }
}
</script>



// WEBPACK FOOTER //
// emt-form.vue?07a5baba